import styled from "styled-components";
import { colors, devices } from "../../utils/styled/_variables.styled";
import { gridNovoConhecer } from "../../utils/styled/_grid.style";
import { TeaserTextContainerProps } from "./TeaserText.types";

export const TeaserTextContainer = styled.div<TeaserTextContainerProps>`
  background-color: ${(props: { $backgroundColor?: string }) =>
    props.$backgroundColor};

${gridNovoConhecer("")}
  .teaser__title {
    color: ${({ $titleColor }) => ($titleColor ? $titleColor : colors.yellow)};
    margin-bottom: 40px;
    font-size: ${({ $fontSizeDeskTitle }) => $fontSizeDeskTitle || "40px"};
    @media ${devices.mobile} {
      margin-bottom: 20px;
      font-size: ${({ $fontSizeMobileTitle }) => $fontSizeMobileTitle || "32px"};
    }
    text-transform: ${({ $titleUpper }) =>
      $titleUpper ? "uppercase" : "unset"};
  }
  .sensia-title-mobile {
    display: none;
    @media ${devices.mobile} {
      display: block;
      margin-bottom: 24px !important;
    }
  }
  .sensia-title-desk {
    display: block;
    margin-bottom: 24px !important;
    @media ${devices.mobile} {
      display: none;
    }
  }
  .sensia-margin {
    margin-bottom: 24px !important;
  }
  .teaser {
    display: flex;
    flex-direction: ${({ $order }) => $order};
    column-gap: 60px;
    justify-content: space-around;
    align-items: ${({ $isBorder }) => $isBorder ? "flex-start" : "center"};
    border: ${({ $isBorder }) => $isBorder ? "1px solid" : "unset"};
    border-color: ${(props: { $borderColor?: string }) =>
    props.$borderColor};
    border-radius: ${({ $isBorder }) => $isBorder ? "16px" : "unset"};


    @media ${devices.mobile} {
      flex-direction: ${({ $order }) => $order === "column" ? "column" : "column-reverse"};
      column-gap: unset;
    }

    .teaser__content {
      padding: ${({ $isBorder }) => $isBorder ? "24px" : "0"};
      @media ${devices.mobile} {
        width: 100%;
      }
      .teaser__subtitle {
        color: ${({ $subtitleColor }) =>
          $subtitleColor ? $subtitleColor : colors.greenDark};
        margin-bottom: 40px;
        font-size: ${({ $fontSizeDeskSub }) => $fontSizeDeskSub || "32px"};
        text-transform: ${({ $subtitleUpper }) =>
          $subtitleUpper ? "uppercase" : "unset"};
        @media ${devices.mobile} {
          margin-bottom: 20px;
          font-size: ${({ $fontSizeMobileSub }) => $fontSizeMobileSub || "24px"};
        }
      }
      .teaser__text {
        margin-bottom: 40px;
        * {
          color: ${({ $textColor }) =>
            $textColor ? $textColor : colors.gray5};
          font-weight: 400;
          font-size: 16px;
          line-height: 175%;

          @media ${devices.mobile} {
            font-size: 14px;
          }
        }
        ul {
          padding: 0 0 0 32px
        }
        @media ${devices.mobile} {
          margin-bottom: 20px;
        }

        b {
          font-weight: 700;
        }
      }

      .sensia-button {
        button {
          min-height: auto !important;
          padding: 9.5px 35px !important;
          @media ${devices.mobile} {
            padding: 5.5px 35px !important;
          }
          & > span {
            font-size: 14px !important;
            font-weight: 600 !important;
            line-height: 150% !important;
          }
        }
      }

      .teaser__buttons {
        display: flex;
        flex-direction: row;
        column-gap: 40px;
        row-gap: 20px;
        flex-wrap: nowrap;

        button{
          width: 50%;
        }

        @media ${devices.tablet} {
          button {
            width: 50%;
            min-width: unset;
          }
          flex-wrap: nowrap;
          column-gap: 20px;
        }
        @media ${devices.mobile} {
          button {
            width: 100%;
            min-width: unset;
          }
          flex-wrap: wrap;
          column-gap: unset;
          row-gap: 20px;
        }
      }
    }

    .teaser__image {
      max-width: 583px;
      height: fit-content;
      margin-top: ${({ $isBorder }) => $isBorder ? "0px" : "20px"};
      margin-bottom: ${({ $isBorder }) => $isBorder ? "0px" : "20px"};
      @media ${devices.tablet} {
        max-width: 300px;
      }
      @media ${devices.mobile} {
        width: 100%;
        max-width: 300px;
        max-width: unset;
        margin-bottom: 20px;
        margin-top: 0px;
      }
    }

    .page-imovel-borderless-content {
      .teaser__buttons {
        button {
          width: fit-content;
          @media ${devices.mobile} {
            width: 100%;
          }
        }
      }
      .teaser__image-borderless {
        display: none;
        max-width: 583px;
        height: fit-content;
        margin-top: ${({ $isBorder }) => $isBorder ? "0px" : "20px"};
        margin-bottom: ${({ $isBorder }) => $isBorder ? "0px" : "20px"};
        @media ${devices.mobile} {
          display: block;
          width: auto;
          max-height: 140px;
          margin: 0 auto 20px;
        }
      }
    }
    .page-imovel-border-content {
      .teaser__buttons {
        justify-content: center;
        button {
          width: fit-content;
        }
      }
      .teaser__text {
        text-align: center;
      }
    }
  }

  .image-borderless {
    display: inline;
    @media ${devices.mobile} {
      width: auto !important;
      max-height: 140px;
      display: none;
    }
  }
  .image-sensia-margin {
    max-height: none !important;
    width: 212px !important;
    height: 212px !important;
    object-fit: contain;
    margin-top: -20px !important;
    @media ${devices.mobile} {
      max-height: none !important;
      width: 212px !important;
      height: 212px !important;
      margin: 0 auto 24px !important;
    }
  }

  &.page-imovel-border-padding {
    padding: 0;
    margin: 0;

    @media ${devices.mobile} {
      padding: 0;
    }

    .teaser {
      max-width: 100%;
      justify-content: space-between;
    }
  }

  &.page-imovel-borderless-padding {
    padding: 40px;
    border-radius: 16px;
    margin: 0;

    @media ${devices.mobile} {
      padding: 24px;
      margin-left: -16px;
      margin-right: -16px;
      border-radius: 0;
    }

    .teaser {
      column-gap: 24px;
    }
  }
`;
